import { Link } from "react-router-dom";
import { MapPin, Mail } from "lucide-react";

const STORAJINI_URL = "https://storajini.com";
const LOGO = "/storajini-logo-full.png";

const footerLinks = {
  services: [
    { label: "Storage Space", href: `${STORAJINI_URL}/search`, external: true },
    { label: "Parking Space", href: `${STORAJINI_URL}/search`, external: true },
  ],
  support: [
    { label: "Contact Us", href: `${STORAJINI_URL}/contact-us`, external: true },
  ],
  company: [
    { label: "About Storajini", href: `${STORAJINI_URL}/about-us`, external: true },
    { label: "How It Works", href: `${STORAJINI_URL}/how-it-works`, external: true },
  ],
  legal: [
    { label: "Privacy Policy", href: "/privacy-policy" },
    { label: "Cookie Policy", href: "/cookie-policy" },
  ],
};

export default function Footer() {
  const renderLink = (link, idx) => {
    if (link.external) {
      return (
        <a key={idx} href={link.href} className="text-gray-500 hover:text-gray-700 transition-colors text-sm">
          {link.label}
        </a>
      );
    }
    return (
      <Link key={idx} to={link.href} className="text-gray-500 hover:text-gray-700 transition-colors text-sm">
        {link.label}
      </Link>
    );
  };

  return (
    <footer data-testid="main-footer" role="contentinfo" aria-label="Site footer" className="bg-gray-50 border-t border-gray-200">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center mb-4">
              <img src={LOGO} alt="Storajini" className="h-10" />
            </Link>
            <p className="text-sm text-gray-500 leading-relaxed mb-4">
              Your trusted partner in finding secure and affordable storage spaces across the Philippines.
            </p>
            <div className="space-y-2">
              <div className="flex items-start gap-2 text-sm text-gray-500">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span>103 10th street New Manila, Quezon City 1112, brgy. Mariana</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-500">
                <Mail className="w-4 h-4 flex-shrink-0" />
                <a href="mailto:support@storajini.com" className="hover:text-amber-600">support@storajini.com</a>
              </div>
              <div className="flex items-center gap-3 mt-3">
                <a href="https://www.facebook.com/storajini" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="text-gray-400 hover:text-amber-500 transition-colors">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
                </a>
                <a href="https://www.instagram.com/storajini" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="text-gray-400 hover:text-amber-500 transition-colors">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>
                </a>
                <a href="https://www.youtube.com/@Storajini" target="_blank" rel="noopener noreferrer" aria-label="YouTube" className="text-gray-400 hover:text-amber-500 transition-colors">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>
                </a>
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-gray-900 mb-3">Services</h3>
            <div className="flex flex-col gap-2.5">{footerLinks.services.map(renderLink)}</div>
          </div>
          <div>
            <h3 className="text-sm font-semibold text-gray-900 mb-3">Support</h3>
            <div className="flex flex-col gap-2.5">{footerLinks.support.map(renderLink)}</div>
          </div>
          <div>
            <h3 className="text-sm font-semibold text-gray-900 mb-3">Company</h3>
            <div className="flex flex-col gap-2.5">{footerLinks.company.map(renderLink)}</div>
          </div>
          <div>
            <h3 className="text-sm font-semibold text-gray-900 mb-3">Legal</h3>
            <div className="flex flex-col gap-2.5">{footerLinks.legal.map(renderLink)}</div>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-gray-200 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-gray-400">
            &copy; {new Date().getFullYear()} Storajini. All rights reserved.
          </p>
          <p className="text-xs text-gray-400">Philippines Storage, Parking & Moving Guide</p>
        </div>
      </div>
    </footer>
  );
}
